<template>
  <div
    :class="`col-md-${configuration.size} ${isAdmin?'admin':''}`"
    class="blockItem   mb-3 d-flex  "
    style="flex-direction: column;  "
  >
    <div style="flex: 1; color: #aaa">
      <div
        v-if="input.title"
        class="font-weight-bold"
      >
        {{ input.title }}
        <span
          v-if="input.required"
          class="text-danger"
        >*</span>
      </div>
      <div
        v-if="input.description"
        class=" mb-1"
      >
        {{ input.description }}
      </div>
    </div>
    <div
      class="mt-1 mb-2"
      style="flex: 1"
    >
      <div v-if="input.inputType ==='file'">
        <div
          v-if="fileList.length>0"
          class="row"
        >
          <div
            v-for="f in fileList"
            class="col-md-6"
          >
            <a
              v-if="isPhoto(f)"
              target="_blank"
              :href="getPhoto(f,'')"
            >
              <img
                :src="getPhoto(f,'medium')"
                class="img-thumbnail"
                style="max-height: 200px;"
                :alt="$t('newRequest.requestPhoto')"
              >
            </a>
            <a
              v-else
              target="_blank"
              :href="getPhoto(f,'')"
              class="card border border-dark "
              style="height: 100%"
            >
              <div class="card-body d-flex text-dark w-100 justify-content-center align-items-center ">
                {{ $t('newAUCRequest.lavFayl') }} <br> *.{{ f.split('.').pop() }}
              </div>
            </a>
          </div>
        </div>
        <div v-else>
          -
        </div>
      </div>
      <div v-else-if="input.inputType ==='select'">
        <span v-if="typeof modelValue === 'object'">
          - {{ modelValue.join(',') || '-' }}
        </span>
        <span v-else>
          -  {{ modelValue || '-' }}
        </span>
      </div>
      <div v-else-if="input.inputType ==='daterange'">
        - {{ dateRangeValue || '-' }}
      </div>

      <div v-else>
        {{ modelValue || '-' }}
      </div>
    </div>
  </div>
</template>
<script>


import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {mapState} from "vuex";
import {baseUrl} from "@/repositories/Repository";
import {getPhoto} from "@/repositories/Utils";

import moment from "moment";

export default {
  name: 'VendorManagementDataView',
  props: [
    'input',
    'isAdmin',
    'modelValue'
  ],
  emits: ['update:modelValue'],
  data() {
    return {
      apiBase: baseUrl,
      configuration: {},
      dateFormat: "dd/MM/yyyy",
      uploadedFiles: []
    }
  },
  watch: {
    uploadedFiles(newVal) {
      this.$emit('update:modelValue', newVal.join(','))
    },
  },
  computed: {
    ...mapState({
      token: state => {
        return state.auth.token
      }
    }),

    fileList() {

      let list = [];

      if (!this.modelValue || this.modelValue === '') {
        return [];
      }

      if (this.input.inputType === 'file') {
        return this.modelValue.split(',');
      }

      return list;

    },

    selectValue() {

      let list = [];

      if (this.input.inputType === 'select') {

        this.configuration.values.split('\n').forEach(v => {
          list.push({
            code: v,
            name: v
          });
        })

      }
      return list;

    },

    dateRangeValue(){
      if(this.modelValue){
        let parts =  this.modelValue.split(' - ');
        return  moment(parts[0]).format('DD MMM YYYY') + ' - ' + moment(parts[1]).format('DD MMM YYYY');
      }
      return '';
    }

  },
  created() {
    this.configuration = JSON.parse(this.input.settings);
  },
  methods: {

    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
  },
  components: {Multiselect, Datepicker, vue2Dropzone}

}
</script>
<style lang="scss" scoped>
.blockItem {
  position: relative;
  padding: 10px 15px;

  .actions {
    position: absolute;
    right: 10px;
    top: 10px;
    display: none;
  }

  &.admin {
    border: 1px dashed #e7e6e6;
  }


  &:hover {
    &.admin {
      border-color: #888888;
      box-shadow: 0 0 2px #0b2e13;

      .actions {
        display: block;
      }
    }
  }


}

::v-deep .dropzone {
  min-height: 50px !important;
}

/*
::v-deep .dz-remove{
  opacity: 1 !important;
}*/
</style>